import React, { Component } from "react";
import { connect } from "react-redux";
import {
    LoanInfoView,
    LeadInfoView,
    PaymentSchedule,
    AccountActivity,
    Banner
} from "./subcomponents/";
import { SlPageTitle, SlBusyIndicator, SlButton, SlFormEntryRow, SlSectionLabel } from "./editors";
import { bindActionCreators } from "redux";
import { loanInfoActions } from "../_actions/loanInfo.actions";
import { newLoanActions } from "../_actions/newloan.actions";
import { profileActions } from "../_actions/profile.actions";
import { documentActions } from "../_actions";

import { Card, CardBody, CardHeader, Collapse, Alert, Row, Col } from "reactstrap";
import { metadataService } from "../_services";
import { history } from "../_helpers";
import { ServiceUtil as serviceUtil } from '../_services/services.util';
import parse from 'html-react-parser';

class AccountHistory extends Component {
    static displayName = AccountHistory.name;
    constructor(props) {
        super(props);
        this.state = {
            branchPhone: '',
            isLoading: true,
            banner: { showBanner: false },
            showPaymentButton: false
        };

        this.loadBanner = this.loadBanner.bind(this);

        document.addEventListener('language', () => {
            this.loadBanner();
        });
    }


    getLeadDescription(lead) {
        switch (lead.leadType) {
            case 7:
                return metadataService.getLabel("RefinanceLoanRequest");
            case 8:
                return metadataService.getLabel("IncreaseLoanRequest");
            default:
                return metadataService.getLabel("NewLoanRequest");
        }

    }

    componentDidMount() {
        const reloadAccountHistory = serviceUtil.getReloadAccountHistory();

        this.loadBanner();

        serviceUtil.isPaymentButtonShown().then(showButton => {
            this.setState({ showPaymentButton: showButton });
        });

        if (!this.props.accountViewsLoaded || reloadAccountHistory) {
            this.props.actions
                .loadProfile()
                .catch(error => alert("Failure => " + error));
            this.props.actions
                .loadAccountViews()
                .catch(error => alert("Failure => " + error));
            this.props.actions
                .getNumberOfReferralsEarned()
                .catch(error => alert("Failure => " + error));
            this.props.actions
                .loadMostRecentLead()
                .catch(error => alert("Failure => " + error));
            this.props.actions
                .isMyDocumentsEnabled()
                .catch(error => alert("Failure => " + error));

            var sunLoanBranchId = serviceUtil.getLocalBranchId();
            var localBranch = null;
            var branchPhone = '';

            if (sunLoanBranchId) {
                metadataService.getBranch(sunLoanBranchId).then(response => {
                    localBranch = response.data;
                    branchPhone = (localBranch) ? localBranch.phone : metadataService.getLabel("SupportPhone");
                    this.setState({
                        branchPhone: branchPhone
                    });
                });
            }
            else {
                branchPhone = metadataService.getLabel("SupportPhone");
                this.setState({
                    branchPhone: branchPhone
                });
            }
            serviceUtil.setReloadAccountHistory(false);
        }

        this.props.actions.loadLeadDocumentsByUser();
    }

    loadBanner() {
        serviceUtil.getBanner().then(bannerResponse => {
            this.setState({ banner: bannerResponse });
        });
    }

    togglePaymentSchedule(vw) {
        this.loadAccountDetails(vw);
        this.props.actions.togglePaymentSchedule(vw);

        //this.props.actions.togglePaymentSchedule(accountView);
    }

    toggleAccountActivity(view) {
        this.loadAccountDetails(view);
        this.props.actions.toggleAccountActivity(view);
    }

    handleViewReferrals() {
        history.push('/refer-friend');
    }

    loadAccountDetails(view) {
        if (!view.detailsLoaded) {
            this.props.actions.loadAccountActivity(view);
        }
    }

    // navigateBack() {
    //   this.props.history.goBack();
    // }
    // navigateToMyDocuments() {
    //   this.props.history.push("my-documents");
    // }

    render() {
        if (this.props.accountViewsLoaded) {
            this.props.accountViews.loanAccountViews.map(lv => this.loadAccountDetails(lv));
        }

        return (
            <div className="account-history-page">
                {/* <SlButton name="Back" onClick={() => this.navigateBack()} /> */}
                <SlPageTitle pageName="MyAccountHistory" />
                <SlBusyIndicator visible={!this.props.accountViewsLoaded} />
                {this.props.accountViewsLoaded && this.props.accountViews != null && this.props.accountViews.isInactiveAccount && (
                    <Card className="px-sm-3 mx-sm-3 mb-1">
                        <CardHeader>
                            <Row>
                                <Col>
                                    <Alert color="danger">
                                        {metadataService.getLabel("AccountInactive")}
                                    </Alert>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <div className='text-centered'>
                                {metadataService.getMessage("AccountNotAvailableHeader")}
                                <ul>
                                    <li>{metadataService.getMessage("AccountNotAvailableReason1")}</li>
                                    <li>{metadataService.getMessage("AccountNotAvailableReason2")}</li>
                                </ul>
                                {metadataService.getMessage("AccountNotAvailableFooter")}
                            </div>
                        </CardBody>
                    </Card>
                )}

                {this.props.accountViewsLoaded && this.props.accountViews != null && !this.props.accountViews.isInactiveAccount && (
                    <div>
                        {this.state.banner.showBanner && (
                            <Banner text={this.state.banner.text} type={this.state.banner.type}></Banner>
                        )}



                        {this.props.accountViewsLoaded && this.props.accountViews.showNoCurrentLoans && (
                            <Card className="px-sm-3 mx-sm-3 mb-1">
                                <CardBody>
                                    <Row>
                                        <Col xs={12}>
                                            <Alert>
                                                {metadataService.getLabel("NoCurrentLoans")}
                                            </Alert>
                                        </Col>
                                    </Row>
                                    {this.props.accountViewsLoaded && this.props.accountViews.showNewLoanRequest && (
                                        <SlFormEntryRow>
                                            <div className="text-center">
                                                <SlButton name="ApplyForANewLoan" onClick={this.props.actions.applyForNewLoan} />
                                            </div>
                                        </SlFormEntryRow>
                                    )}
                                </CardBody>
                            </Card>
                        )}
                        {this.props.accountViews != null && !this.props.accountViews.showNoCurrentLoans && this.props.accountViews.loanAccountViews.map(function (view) {
                            return (
                                <div key={view.currentLoanId} className="px-sm-3 mx-sm-3 mb-1">

                                    <LoanInfoView loanView={view} showHistory="true"
                                        showPaymentButton={this.state.showPaymentButton && view.onlinePaymentsEnabled}
                                        showIncreaseRefinance={this.props.accountViews.showIncreaseRefinance} />

                                    {/*Temp hotfix - this should be a lookup table*/}
                                    {view.thirdPartyName === "ACSI" && 
                                        <div className="font-bold">{
                                            parse(metadataService.getMessage('ThirdParty', "ACSI", "+18004672316", "1-800-467-2316", "8am", "5pm", "8am", "2pm CST", "https://automatedcollections.com/contact/"))
                                        }</div>
                                    }
                                    {view.thirdPartyName === "FHC" &&
                                        <div className="font-bold">{
                                            parse(metadataService.getMessage('ThirdParty', "FHC", "+18777509804", "1-877-750-9804", "8am", "8pm", "8am", "5pm EST", "https://www.fhcann.com/contact/"))
                                        }</div>
                                    }
                                    {view.scheduledPayments.length > 0 && view.thirdPartyName == null &&
                                        <Card className={"mb-1"}>
                                            <CardHeader onClick={() => this.togglePaymentSchedule(view)} className='twisty' aria-expanded={view.showPaymentSchedule}>
                                                <strong className="h6-title">
                                                    {metadataService.getTitle('PaymentSchedule')}
                                                </strong>
                                            </CardHeader>
                                            <Collapse isOpen={view.showPaymentSchedule}>
                                                <CardBody>
                                                    <PaymentSchedule
                                                        scheduledPayments={view.scheduledPayments} showAsterisk={this.props.accountViews.loanAccountViews.find(lv => lv.scheduledPayments.length > 1)}
                                                    />
                                                </CardBody>
                                            </Collapse>
                                        </Card>
                                    }
                                    {view.thirdPartyName == null &&
                                        <Card className={"mb-1 "}>
                                            <CardHeader onClick={() => this.toggleAccountActivity(view)} className='twisty' aria-expanded={view.showAccountActivity}>
                                                <strong className="h6-title">{metadataService.getTitle('AccountActivity')}</strong>
                                            </CardHeader>
                                            <Collapse isOpen={view.showAccountActivity}>
                                                <CardBody>
                                                    <AccountActivity accountActivity={view.accountActivity} showAsterisk={false} />
                                                </CardBody>
                                            </Collapse>
                                        </Card>
                                    }
                                </div>
                            );
                        }, this)}

                        {this.props.accountViewsLoaded && (
                            <Card className="px-sm-3 mx-sm-3 mb-1">
                                <CardHeader  >
                                    <strong className="h6-title mb-3">{metadataService.getTitle('ApplicationRequests')}</strong>
                                </CardHeader>
                                <CardBody className="m-0 p-0 mt-3">
                                    {this.props.accountViews != null && this.props.accountViews.leadRequests.map(function (lead) {
                                        return (
                                            <div key={lead.leadId} style={{ marginBottom: '10px' }}>
                                                <LeadInfoView
                                                    lead={lead}
                                                    showDocumentsNeeded={this.props.accountViews.documentsNeededLeadIds.find(id => id === lead.leadId) !== undefined}
                                                />
                                            </div>
                                        );
                                    }, this)}
                                </CardBody>
                            </Card>
                        )}

                        {this.props.numberOfReferralsEarned > 0 && (
                            <Row className="m-3 p-3">
                                <Alert color='success'>
                                    {metadataService.getMessage("ReferralsEarned", this.props.numberOfReferralsEarned)}
                                    <SlButton name="View" onClick={this.handleViewReferrals} />
                                </Alert>
                            </Row>)}
                    </div>
                )}
            </div >
        );
    }
}

function mapStateToProps(state) {
    return {
        accountViews: state.loanInfo.accountViews,
        accountViewsLoaded: state.loanInfo.accountViewsLoaded,
        loanViews: state.loanInfo.loanViews,
        loanViewsLoaded: state.loanInfo.loanViewsLoaded,
        numberOfReferralsEarned: state.loanInfo.numberOfReferralsEarned,
        lastLead: state.loanInfo.lastLead,
        leads: state.loanInfo.leads,
        leadsLoaded: state.loanInfo.leadsLoaded,
        accountDocumentsLoading: state.documents.accountDocumentsLoading,
        accountDocuments: state.documents.accountDocuments,
        accountDocumentError: state.documents.accountDocumentError,
        accountDocsRejected: state.documents.accountDocsRejected,
        idDocuments: state.documents.idDocuments,
        idDocumentError: state.documents.idDocumentError,
        idDocsRejected: state.documents.idDocsRejected,
        allDocsAccepted: state.documents.allDocsAccepted,
        idDocumentsLoading: state.documents.idDocumentsLoading
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            loadAccountViews: bindActionCreators(
                loanInfoActions.loadAccountViews,
                dispatch
            ),
            loadProfile: bindActionCreators(
                profileActions.loadProfile,
                dispatch
            ),
            togglePaymentSchedule: bindActionCreators(
                loanInfoActions.togglePaymentSchedule,
                dispatch
            ),
            toggleAccountActivity: bindActionCreators(
                loanInfoActions.toggleAccountActivity,
                dispatch
            ),
            loadAccountActivity: bindActionCreators(
                loanInfoActions.loadAccountActivity,
                dispatch
            ),
            getNumberOfReferralsEarned: bindActionCreators(
                loanInfoActions.getNumberOfReferralsEarned,
                dispatch
            ),
            loadLeads: bindActionCreators(
                loanInfoActions.loadLeads,
                dispatch
            ),
            loadMostRecentLead: bindActionCreators(
                loanInfoActions.loadMostRecentLead,
                dispatch
            ),
            loadAccountDocuments: bindActionCreators(
                documentActions.loadAccountDocuments,
                dispatch
            ),
            loadLeadDocumentsByUser: bindActionCreators(
                documentActions.loadLeadDocumentsByUser,
                dispatch
            ),
            applyForNewLoan: bindActionCreators(
                newLoanActions.handleNewLoanMenuClick,
                dispatch
            ),
            isMyDocumentsEnabled: bindActionCreators(
                documentActions.isMyDocumentsEnabled,
                dispatch
            ),
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AccountHistory);
